module.exports = __webpack_public_path__ + "img/swater-licence-active.2b89992c.svg";